import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

export default function LoginPage() {
  const { login } = useApp();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    const result = await login(username.trim(), password);
    if (!result.ok) setError(result.error || 'Invalid username or password');
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1C1B2E 0%, #2d2b48 50%, #1C1B2E 100%)' }}>
      <div style={{ width: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#fff', letterSpacing: -0.5 }}>WM Payments</div>
          <div style={{ fontSize: 14, color: '#8887a8', marginTop: 6 }}>Payment Workflow Tool</div>
        </div>
        <div style={{ background: '#fff', borderRadius: 16, padding: 32, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 24 }}>Staff sign in</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 6, color: '#444' }}>Username</label>
              <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="Your username" required />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 6, color: '#444' }}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" required />
            </div>
            {error && <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}
            <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
          <div style={{ marginTop: 20, padding: '14px', background: '#f9f8f5', borderRadius: 8, textAlign: 'center' }}>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>Are you a beneficiary?</div>
            <button onClick={() => { window.location.hash = 'beneficiary'; }} style={{ background: '#EEEDFE', border: '1px solid #CECBF6', borderRadius: 8, padding: '8px 20px', color: '#534AB7', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>→ Open beneficiary portal</button>
          </div>
        </div>
      </div>
    </div>
  );
}
